import React from "react";

export default (property, trueValue, falseValue, getter, setter) => [
    getter(property) == trueValue,
    () => setter(property, getter(property) == trueValue ? falseValue : trueValue, true)
]